import React from 'react'
import { Link as RouterLink, useLoaderData,createBrowserRouter, createRoutesFromElements, Navigate, Await, BrowserRouter, Route, Routes, NavLink, useNavigate, useLocation, useOutlet} from 'react-router-dom'
const taiwlind_config_code= `/** @type {import('tailwindcss').Config} */
            module.exports = {
            content: ['./src/**/*.{js,jsx,ts,tsx}'],
            theme: {
               extend: {},
            },
            plugins: [],
            }`
const tailwind_test_code = `<div className='bg-red-300'>test</div>`
export default function ReactPage3(){
     return(
         <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px]'>
         <h2 className='mb-4 text-lg structure__main__subttl'>Deploy your frontend work</h2>
         <p className='text-sm mb-4'>If you want to deploy frontend work, deploy your codes from aws, github, vercel, and netlify for free. For professionals, purchase domain and contract hosting company to rent server.</p>
         {/* <h2 className='mb-4 text-lg structure__main__subttl'>Cpanel</h2>
         <h2 className='mb-4 text-lg structure__main__subttl'>Github</h2>
         <h2 className='mb-4 text-lg structure__main__subttl'>netlify</h2>
         <h2 className='mb-4 text-lg structure__main__subttl'>AWS s3</h2> */}
         </div>
     )
}